import React, { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { useFocus } from '../services/customHooks';

const FocusWrapper = forwardRef((props, ref) => {
  const { children, tabIndex } = props;
  const [inputRef, setInputFocus] = useFocus();

  useImperativeHandle(
    ref,
    () => ({
      focus() {
        inputRef.current.className = 'focus-wrapper';
        setInputFocus('focus');
      },
      blur() {
        setInputFocus('blur');
        inputRef.current.className = '';
      },
      focusWithTimeout(timeout) {
        inputRef.current.className = 'focus-wrapper';
        setInputFocus('default', timeout);
      },
    }),
  );

  return (
    <div tabIndex={tabIndex} ref={inputRef}>
      {children}
    </div>
  );
});

FocusWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  tabIndex: PropTypes.number,
};

FocusWrapper.defaultProps = {
  tabIndex: -1,
};

export default FocusWrapper;
